import React, { useState, useEffect } from 'react';
import styles from './ApiSidebar.module.scss';

const ApiSidebar = ({ apiGroups, onApiSelect, selectedApi, searchTerm, onSearchChange, onDownload, isOpen, onClose }) => {
  const [openGroup, setOpenGroup] = useState(null);

  useEffect(() => {
    if (selectedApi) {
      for (const mainGroupName in apiGroups) {
        const mainGroup = apiGroups[mainGroupName];
        for (const subGroupName in mainGroup.groups) {
          const subGroup = mainGroup.groups[subGroupName];
          if (subGroup.apis.some(api => api.id === selectedApi.id)) {
            setOpenGroup(subGroupName);
            return;
          }
        }
      }
    }
  }, [selectedApi, apiGroups]);


  const toggleGroup = (groupName) => {
    setOpenGroup(prevOpenGroup => (prevOpenGroup === groupName ? null : groupName));
  };

  const handleApiSelection = (mainGroupSlug, subGroupSlug, apiSlug) => {
    onApiSelect(mainGroupSlug, subGroupSlug, apiSlug);
    onClose();
  };

  const filteredApiGroups = Object.fromEntries(
    Object.entries(apiGroups).map(([mainGroupName, mainGroup]) => {
      const filteredSubGroups = Object.fromEntries(
        Object.entries(mainGroup.groups)
          .map(([subGroupName, subGroup]) => {
            const filteredApis = subGroup.apis.filter(api =>
              api.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
              subGroupName.toLowerCase().includes(searchTerm.toLowerCase()) ||
              mainGroupName.toLowerCase().includes(searchTerm.toLowerCase())
            );
            return [subGroupName, { ...subGroup, apis: filteredApis }];
          })
          .filter(([, subGroup]) => subGroup.apis.length > 0)
      );
      return [mainGroupName, { ...mainGroup, groups: filteredSubGroups }];
    }).filter(([, mainGroup]) => Object.keys(mainGroup.groups).length > 0)
  );

  return (
    <div className={`${styles.apiSidebar} ${isOpen ? styles.open : ''}`}>
      <div className={styles.sidebarHeader}>
        <h4>API Reference</h4>
        <button onClick={onClose} className={styles.closeButton}>
          <i className="material-icons">close</i>
        </button>
      </div>
      <input
        type="text"
        placeholder="Search APIs..."
        className={styles.searchInput}
        value={searchTerm}
        onChange={e => onSearchChange(e.target.value)}
      />
      <div className={styles.apiList}>
        {Object.entries(filteredApiGroups).map(([mainGroupName, mainGroup]) => (
          <div key={mainGroupName} className={styles.mainApiGroup}>
            <div className={styles.mainGroupHeader}>
              <span>{mainGroupName}</span>
            </div>
            {Object.entries(mainGroup.groups).map(([subGroupName, subGroup]) => (
              <div key={subGroupName} className={styles.apiGroup}>
                <div className={styles.groupHeader} onClick={() => toggleGroup(subGroupName)}>
                  <span>{subGroupName}</span>
                   <i className={`material-icons ${styles.groupIcon} ${openGroup === subGroupName ? styles.open : ''}`}>
                    keyboard_arrow_down
                  </i>
                </div>
                {openGroup === subGroupName && (
                  <ul>
                    {subGroup.apis.map((a) => (
                      <li
                        key={a.id}
                        className={`${styles.apiListItem} ${selectedApi?.id === a.id ? styles.active : ''}`}
                        onClick={() => handleApiSelection(mainGroup.slug, subGroup.slug, a.slug)}
                      >
                        <span className={`${styles.method} ${styles[a.method.toLowerCase()]}`}>{a.method}</span>
                        <span className={styles.name}>{a.name}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className={styles.sidebarFooter}>
        <button className={styles.downloadButton} onClick={onDownload}>
          <span className="material-icons">download</span>
          Download Postman Collection
        </button>
      </div>
    </div>
  );
};

export default ApiSidebar;